/* eslint-disable */

import { Fragment, useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { VerticalDotsSvg } from "../../assets/svgs";
import { BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
import { providerInstitutionConstant } from "../../constants/user-constants";
import { getCardRegistry, resetSelected } from "../../redux/slices/card-status-management-slice";
import ViewCardStatusModal from "../../components/view-card-status-modal";


const CardStatusManagement = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, cardRegistryData, pagination } = useSelector((state) => state.cardStatusManagementReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);
    const MenuList = Menus({ user });
    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 10,
    };
    const initialOrderBy = {
        sortColumn: "updatedAt",
        isAsce: false,
    };

    const initialSearch = {
        // id: "",
        // bin: "",
        // pan: "",
        // status: "",
        // enrolled: "",
        // domestic: "",
        // international: "",
        // lastSource: "",
        // createdAt: "",
        // updatedAt: ""
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        orderBy: initialOrderBy,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,

    };

    const [states, setStates] = useState(initialStates);

    const defaultParams = {
        pagination: states.pagination,
        orderBy: states.orderBy,
        search: states.search
    };

    const getCardRegistryData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    dispatch(getCardRegistry({ user, ...updatedParams })),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        }
    };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getCardRegistryData(params);
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleModalOpen = (row) => {
        setStates((old) => ({ ...old, isModalOpen: true, selected: row }));
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
        dispatch(resetSelected());
    };
    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        
        const cleanedSearch = Object.keys(searchToUse).reduce((acc, key) => {
            const value = searchToUse[key];
            if (value !== '' && value !== null && value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        
        const params = {
            ...defaultParams,
            search: cleanedSearch,
            pagination: initialPagination,
        };
        getCardRegistryData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search };
            
            if (value === '' || value === null || value === undefined) {
                delete updatedSearch[key];
            } else {
                updatedSearch[key] = value;
            }
            
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

   const actions = (id) => {
        const actionsList = [
            { label: 'View more', action: () => handleModalOpen(id) },
        ];

        return actionsList;
    };

    useEffect(() => {
        getCardRegistryData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Array.isArray(cardRegistryData)) {
            setStates((old) => ({ ...old, data: cardRegistryData, pagination }));
        }
    }, [cardRegistryData, pagination]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const columns = useMemo(() => [
        {
            accessor: 'id', Header: 'Card ID', minWidth: 110, sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="cardId"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('id', e.target.value); }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            handleTableFilterChange('id', e.target.value, true);
                        }
                    }}
                    placeholder="Search by ID"
                    style={{ width: '100%' }}
                />
            )
        },
        {
            accessor: 'bin', Header: 'BIN', minWidth: 120, sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="bin"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('bin', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('bin', e.target.value, true); }}
                    placeholder="Search by BIN"
                    style={{ width: '100%' }}
                />
            )
        },
        {
            accessor: 'pan', Header: 'PAN', minWidth: 150, sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="pan"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('pan', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('pan', e.target.value, true); }}
                    placeholder="Search by PAN"
                    style={{ width: '100%' }}
                />
            )
        },
        {
            accessor: 'email', Header: 'Email', minWidth: 180, sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="email"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('email', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('email', e.target.value, true); }}
                    placeholder="Search by Email"
                    style={{ width: '100%' }}
                />
            )
        },
        {
            accessor: 'mobile', Header: 'Mobile Number', minWidth: 150, sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="mobile"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('mobile', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('mobile', e.target.value, true); }}
                    placeholder="Search by Mobile"
                    style={{ width: '100%' }}
                />
            )
        },
        // {
        //     accessor: 'expiryDate',
        //     Header: 'Expiry Date',
        //     minWidth: 160,
        //     Cell: row => row?.original?.expiryDate ? moment(row?.original?.expiryDate).format('MM / YY') : '',
        //      Filter: ({ filter, onChange }) => (
        //         <input
        //             type="month"
        //             name="expiryDate"
        //             value={filter ? filter.value : ''}
        //             onChange={(e) => {
        //                 const value = e.target.value;
        //                 onChange(value);
        //                 handleTableFilterChange('expiryDate', value, true);
        //             }}
        //             style={{ width: '100%' }}
        //         />
        //     ),
        //     sortable: false,
        // },
        {
            accessor: 'status',
            Header: 'Status',
            minWidth: 140,
            sortable: false,
            Cell: row => {
                const status = row?.original?.status?.toLowerCase();
                let type = 'default';
                if (status === 'active') type = 'success';
                else if (status === 'warm' || status === 'expired' || status === 'pending') type = 'warning';
                else if (status === 'hot' || status === 'blocked' || status === 'block') type = 'error';
                else if (status === 'fresh') type = 'default';
                return <BadgeComponent label={status} type={type} />;
            },
            Filter: ({ filter, onChange }) => (
                // <select
                //     value={filter ? filter.value : ''}
                //     onChange={e => { onChange(e.target.value); handleTableFilterChange('status', e.target.value, true); }}
                //     style={{ width: '100%' }}
                // >
                //     <option value="">All</option>
                //     <option value="Active">Active</option>
                //     <option value="Warm">Warm</option>
                //     <option value="Hot">Hot</option>
                //     <option value="Fresh">Fresh</option>
                // </select>
                <input
                    type="text"
                    name="status"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('status', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('status', e.target.value, true); }}
                    placeholder="Search by status"
                    style={{ width: '100%' }}
                />
            )
        },
        // {
        //     accessor: 'enrolled',
        //     Header: 'Enrolled',
        //     minWidth: 100,
        //     sortable: false,
        //     Filter: ({ filter, onChange }) => (
        //         <select
        //             value={filter ? filter.value : ''}
        //             onChange={e => { 
        //                 const value = e.target.value === 'Yes' || e.target.value === 'No' ? e.target.value : '';
        //                 onChange(e.target.value); 
        //                 handleTableFilterChange('enrolled', value, true);   
        //             }}
        //             style={{ width: '100%' }}
        //         >
        //             <option value="">All</option>
        //             <option value="Yes">Yes</option>
        //             <option value="No">No</option>
        //         </select>
        //     )
        // },
        // {
        //     accessor: 'domestic',
        //     Header: 'Domestic',
        //     minWidth: 100,
        //     sortable: false,
        //     Filter: ({ filter, onChange }) => (
        //         <select
        //             value={filter ? filter.value : ''}
        //             onChange={e => { 
        //                 const value = e.target.value === 'Yes' || e.target.value === 'No' ? e.target.value : '';
        //                 onChange(e.target.value); 
        //                 handleTableFilterChange('domestic', value, true); 
        //             }}
        //             style={{ width: '100%' }}
        //         >
        //             <option value="">All</option>
        //             <option value="Yes">Yes</option>
        //             <option value="No">No</option>
        //         </select>
        //     )
        // },
        // {
        //     accessor: 'international',
        //     Header: 'International',
        //     minWidth: 120,
        //     sortable: false,
        //     Filter: ({ filter, onChange }) => (
        //         <select
        //             value={filter ? filter.value : ''}
        //             onChange={e => { 
        //                 const value = e.target.value === 'Yes' || e.target.value === 'No' ? e.target.value : '';
        //                 onChange(e.target.value); 
        //                 handleTableFilterChange('international', value, true); 
        //             }}
        //             style={{ width: '100%' }}
        //         >
        //             <option value="">All</option>
        //             <option value="Yes">Yes</option>
        //             <option value="No">No</option>
        //         </select>
        //     )
        // },
        // { accessor: 'mccBlocks', Header: 'MCC Blocks', minWidth: 110, sortable: false, Cell: row => row?.original?.mccBlocks?.length || 0, filterable: false },
        // { accessor: 'countryBlocks', Header: 'Country Blocks', minWidth: 130, sortable: false, Cell: row => row?.original?.countryBlocks?.length || 0, filterable: false },
        {
            accessor: 'lastSource',
            Header: 'Last Source',
            minWidth: 140,
            sortable: false,
            Cell: row => (<div style={{ textTransform: 'capitalize' }}>{row?.original?.lastSource?.toLowerCase()}</div>),
            Filter: ({ filter, onChange }) => (
                // <select
                //     value={filter ? filter.value : ''}
                //     onChange={e => { onChange(e.target.value); handleTableFilterChange('lastSource', e.target.value, true); }}
                //     style={{ width: '100%' }}
                // >
                //     <option value="">All</option>
                //     <option value="FILE">FILE</option>
                //     <option value="MANUAL">MANUAL</option>
                // </select>
                <input
                    type="text"
                    name="lastSource"
                    value={filter ? filter.value : undefined}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('lastSource', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('lastSource', e.target.value, true); }}
                    placeholder="Search by source"
                    style={{ width: '100%' }}
                />
            )
        },
        {
            accessor: 'updatedDate',
            Header: 'Updated At',
            minWidth: 160,
            Cell: row => row?.original?.updatedDate ? moment(row?.original?.updatedDate).format('lll') : '',
             Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="updatedAt"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('updatedAt', value, true);
                    }}
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'createdDate',
            Header: 'Created At',
            minWidth: 160,
            Cell: row => row?.original?.createdDate ? moment(row?.original?.createdDate).format('lll') : '',
             Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="createdAt"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('createdAt', value, true);
                    }}
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            Cell: row => (
                <div className="action-dropdown" style={{ position: 'absolute' }}>
                    <IconButtonComponent
                        outline={!(states.isDropdownOpen && states.selected === row?.original)}
                        size='small'
                        icon={VerticalDotsSvg}
                        onClick={() => handleSelectRow(row?.original)}
                    />
                    <DropDownComponent
                        isOpen={states.isDropdownOpen && states.selected === row?.original}
                        close={handleCloseDropdown}
                        actions={actions(row?.original)}
                    />
                </div>
            ),
            filterable: false,
            sortable: false,
        }
    ], [states.isDropdownOpen, states.selected]);

    return (
        <AuthPageContainer $heightfull>
            <BackButton />
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Card Registry</h1>
                    <Breadcrumbs
                        items={[{ label: "Home", to: "/app/home" }, { label: PageLabel }]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {loading && <LoaderComponent />}

            <>
                <PaginationComponent
                    page={states?.pagination?.currentPage}
                    pages={states?.pagination?.totalPages || 1}
                    onPageChange={(e) => handlePagination(e)}
                    canPrevious={states?.pagination?.currentPage > 0}
                    canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                />
                <ReactTableWrapper className="box-shadow custom-scrollbar">
                    <ReactTableWrappers>
                        <ReactTable
                            manual
                            loading={loading}
                            data={states?.data}
                            columns={columns}
                            page={states?.pagination?.currentPage || 0}
                            pageSize={states?.pagination?.pageSize || 20}
                            pages={states?.pagination?.totalPages || 1}
                            filterable={true}
                            showPagination={false}
                            showPageJump={true}
                            showPageSizeOptions={false}
                            showPaginationTop={true}
                            showPaginationBottom={false}
                            onPageChange={(e) => handlePagination(e)}
                            minRows={0}
                        />
                    </ReactTableWrappers>
                </ReactTableWrapper>
            </>

            {states.isModalOpen && (
                <ViewCardStatusModal
                    data={states.selected}
                    close={handleModalClose}
                    label="Card Details"
                    slide
                />
            )}
        </AuthPageContainer>
    );
};

export default CardStatusManagement;
